import templateUrl from './restaurantInfo.html';

export const RestaurantInfoComponent = {
    templateUrl,
    transclude: true,
    controller: function(
        $rootScope,
        $state,
        cartService,
        googleAnalyticsTrackingService,
        loginModalService,
        orderInfoService,
        restaurantInfoFactory
    ) {
        'ngInject';

        const vm = this;

        vm.loginModal = loginModalService;

        vm.closeLoginModal = closeLoginModal;

        vm.isCartPage = $state.current.name === 'order' || this.showCart;

        vm.$onInit = activate;
        vm.openMenuEvent = googleAnalyticsTrackingService.getOpenMenuEvent();
        vm.loginSuccessCallback = () => {
            vm.loginModal.close();
            googleAnalyticsTrackingService.trackLoginSuccess();
        };
        vm.loginErrorCallback = errorMessage => googleAnalyticsTrackingService.trackLoginError(errorMessage);
        vm.forgotPasswordCallback = () => googleAnalyticsTrackingService.trackForgotPassword();
        vm.sendInstructionsCallback = () => googleAnalyticsTrackingService.trackSendInstructions();
        vm.forgotPasswordSuccessCallback = () => closeLoginModal();
        vm.createAccountSuccessCallback = () => {
            vm.loginModal.close();
            googleAnalyticsTrackingService.trackCreateAccountSuccess();
        };
        vm.createAccountErrorCallback = errorMessage => googleAnalyticsTrackingService.trackCreateAccountError(errorMessage);
        vm.logoutCallback = () => orderInfoService.clearAllData();
        vm.termsOfServiceCallback = () => googleAnalyticsTrackingService.trackTermsOfService();
        vm.privacyPolicyCallback = () => googleAnalyticsTrackingService.trackPrivacyPolicy();

        function activate() {
            cartService.getCart().then(function() {
                vm.cartData = cartService.getCartData();
            });
            restaurantInfoFactory.getInfo(['general', 'imageSet', 'restaurantAddress', 'onlineOrder']).then(info => {
                vm.restaurantInfo = info;
            });

            $rootScope.$on('$stateChangeSuccess', function(event, toState) {
                vm.isCartPage = toState.name === 'order' || toState.name === 'order.cart';
            });
        }

        function closeLoginModal() {
            vm.loginModal.close();
        }
    }
};
